var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09988 8.0001C2.09988 4.75624 4.75603 2.1001 7.99988 2.1001C11.2437 2.1001 13.8999 4.75624 13.8999 8.0001C13.8999 11.244 11.2437 13.9001 7.99988 13.9001C4.75603 13.9001 2.09988 11.244 2.09988 8.0001Z",
    stroke: "#858894"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58943 9.09559H8.47906C8.68436 9.09559 8.82123 8.95872 8.82123 8.75342L8.9581 4.57898C8.9581 4.37368 8.82123 4.23682 8.61593 4.23682H7.38413C7.17883 4.23682 7.04196 4.37368 7.04196 4.57898L7.17883 8.75342C7.24726 8.95872 7.38413 9.09559 7.58943 9.09559Z",
    fill: "#858894"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 9.84836C7.45256 9.84836 7.04196 10.259 7.04196 10.8064C7.04196 11.3539 7.45256 11.7645 8.00003 11.7645C8.47906 11.7645 8.9581 11.3539 8.9581 10.8064C8.9581 10.259 8.47906 9.84836 8.00003 9.84836Z",
    fill: "#858894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.5a2e3f4e21ba013083271a7fd944afde.svg";
export { ForwardRef as ReactComponent };